module.exports = __webpack_public_path__ + "static/media/modis2911.d89d1f46.jpg";